import { withAuthenticationRequired } from '@tom-ui/utils'
import { ContainerMasterDataFormPage } from '@tom-ui/planning'
import { renderIsoCodeMappingInputWithDetails } from '../IsoCodeMapping/IsoCodeMappingWrapper'

export const ContainerMasterDataWrapper = withAuthenticationRequired(() => {
  return (
    <ContainerMasterDataFormPage renderIsoCodeMappingInput={renderIsoCodeMappingInputWithDetails} />
  )
})
